import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "./store";

interface OrganisationState {
  selectedOrganisationId: string;
}

const initialState: OrganisationState = {
  selectedOrganisationId: sessionStorage.getItem("selectedOrgId") || "",
};

const organisationSlice = createSlice({
  name: "organisation",
  initialState,
  reducers: {
    setSelectedOrganisation: (state, action: PayloadAction<string>) => {
      state.selectedOrganisationId = action.payload;
      sessionStorage.setItem("selectedOrgId", action.payload);
    },
    clearSelectedOrganisation: (state) => {
      state.selectedOrganisationId = "";
      sessionStorage.removeItem("selectedOrgId");
    },
  },
});

export const { setSelectedOrganisation, clearSelectedOrganisation } =
  organisationSlice.actions;

// Selectors
export const selectOrganisationId = (state: RootState) =>
  state.organisation.selectedOrganisationId;

export default organisationSlice.reducer;

